import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "@/shop/CartContext";
import SignalNav from "@/shop/SignalNav";
import CartDrawer from "@/shop/CartDrawer";
import SignalFooter from "@/shop/SignalFooter";

export default function ShopLayout() {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    lenisRef.current?.scrollTo(0, { immediate: true });
  }, [pathname]);

  return (
    <CartProvider>
      <div className="signal min-h-screen" data-testid="shop-root">
        <SignalNav />
        <main><Outlet /></main>
        <SignalFooter />
        <CartDrawer />
      </div>
    </CartProvider>
  );
}
